import React from "react";

import { Button, Grid, Stack, Typography } from "@mui/material";

import { StyledTextField, Box1400 } from "./styles";

const Newsletter = () => {
  return (
    <Box1400 sx={{ marginTop: 20 }}>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Typography variant="h1" color="common.white">
            Subscribe to our
          </Typography>
          <Typography
            variant="h1"
            color="primary"
            className="text-glow-primary"
          >
            Newsletter
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} sx={{ margin: "auto" }}>
          <Stack direction="row" sx={{ alignItems: "end" }}>
            <StyledTextField label="Email" variant="standard" color="primary" />
            <Button size="medium" sx={{ height: "fit-content" }}>
              Subscribe
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box1400>
  );
};

export default Newsletter;
